<h5 class="titulo">Produtos Permitidos para Operações de Repasse</h5>
<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" (click)="chamaModalCadastroProdutosPermitidos()"><i class="fa fa-file-signature">
        </i> Cadastrar Novo Produto
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                (click)="buscar()">Pesquisar
        </button>
      </div>
    </div>
    <div class="row mt-4">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="idProduto"><b>Código do Produto: </b></label>
        <ng-select
          [items]="listaTodosProdutos"
          bindLabel="sigla"
          bindValue="id"
          placeholder="Todos"
          formControlName="idProduto"
          ngDefaultControl
        >
        </ng-select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="permitido"><b>Operação Permitida: </b></label>
        <i class="fa fa-question-circle help-subtitulo"
           placement="bottom"
           ngbTooltip="Informa se o Código de modalidade operacional é permitido"></i>
        <ng-select
          [items]="listaOpercaoPermitida"
          bindLabel="nome"
          bindValue="valor"
          placeholder="Todos"
          formControlName="permitido"
          ngDefaultControl
        >
        </ng-select>
      </div>
    </div>
  </form>
</div>

<app-produtos-permitidos-listagem
  *ngIf="pesquisado && produtosPermitidos.length"
  [produtosPermitidos]="produtosPermitidos"
  (atualizarListagem)="atualizarListagem()"
>
</app-produtos-permitidos-listagem>

<section class="container" *ngIf="pesquisado && (!produtosPermitidos || !produtosPermitidos.length)">
  <div class="alert alert-info">
    Não foram encontradas produtos permitidos com os filtros informados.
  </div>
</section>
